import { useState, useEffect } from 'react';
import Thumbnail from "./Thumbnail";
import VideoPresentation from "./VideoPresentation";
import videos from "../videos.json";
import "../style/pillars-section.css";

export default function PillarsSection() {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [ceMejiPlayed, setCeMejiPlayed] = useState(false);

    useEffect(() => {
        if (selectedIndex !== 0) {
            setCeMejiPlayed(true);
        }
    }, [selectedIndex]);

    const handleThumbnailClick = (index) => {
        setSelectedIndex(index);
    };

    const shouldAutoplay = selectedIndex !== 0 || (selectedIndex === 0 && ceMejiPlayed);

    return (
        <section className="pillars">
            <h1 className="top-block">The 5 pillars of IFA</h1>
            <div className="block thumbnail-container">
                {videos.map((video, index) => (
                    <Thumbnail
                        key={video.name}
                        handleClick={() => handleThumbnailClick(index)}
                        video={video}
                        selectedIndex={selectedIndex}
                        index={index}
                    />
                ))}
            </div>
            <VideoPresentation
                video={videos[selectedIndex]}
                autoplay={shouldAutoplay} // Adjust autoplay logic
            />
        </section>
    );
}
